import { BASE_URL } from '../../../../config/environmentConfig';
import { Dispatch } from 'react';
import { IAction } from '../merchant-interfaces';
import { merchantActionTypes } from '../action-types';
import {
	FUNDS_RESERVE_CONFIG_FORM_FIELDS,
	FundsReserveConfigFieldsReturnTypes,
	getFormattedFundsReserveConfigFields,
} from '../../../constants/funds-reserve-config/funds-reserve-config-form';
import { DELETE, GET, PUT } from '../../store-helper';

export const fetchFundsReserveConfigLists = async (dispatch: Dispatch<IAction>): Promise<void> => {
	try {
		const res = await GET({
			pathname: `${BASE_URL.MERCHANTS}/fundsReserve/list`
		});

		const lists = {
			types: [],
			rateTypes: [],
		};

		const configLists = ['types', 'rateTypes'];

		configLists.map(el => {
			lists[el] = Object.entries(res[el] || {})?.map(([key, val]) => ({
				value: Number(key),
				label: val
			}));
		});
		dispatch({ type: merchantActionTypes.FETCH_FUNDS_RESERVE_CONFIG_LISTS, payload: lists });

	} catch (e) {
		console.log('fetchFundsReserveConfigLists error', e);
		dispatch({ type: merchantActionTypes.FETCH_FUNDS_RESERVE_CONFIG_LISTS, payload: {}});
	}
};

export const fetchFundsReserveConfigActive = async (dispatch: Dispatch<IAction>): Promise<void> => {
 try {
	 dispatch({ type: merchantActionTypes.SET_FUNDS_RESERVE_CONFIG_ACTIVE_LIST_DATA_LOADING, payload: true });

	 const res = await GET({
		 pathname: `${BASE_URL.MERCHANTS}/fundsReserve?isActive=true`
	 });

	 dispatch({ type: merchantActionTypes.FETCH_FUNDS_RESERVE_CONFIG_ACTIVE, payload: res ?? [] });

 } catch (e) {
	 console.log('fetchFundsReserveConfigList error', e);
	 dispatch({ type: merchantActionTypes.SET_FUNDS_RESERVE_CONFIG_ACTIVE_LIST_DATA_LOADING, payload: false });
 }
};

export const fetchFundsReserveConfigInactive = async (dispatch: Dispatch<IAction>): Promise<void> => {
	try {
		dispatch({ type: merchantActionTypes.SET_FUNDS_RESERVE_CONFIG_INACTIVE_LIST_DATA_LOADING, payload: true });

		const res = await GET({
			pathname: `${BASE_URL.MERCHANTS}/fundsReserve?isActive=false`
		});

		dispatch({ type: merchantActionTypes.FETCH_FUNDS_RESERVE_CONFIG_INACTIVE, payload: res ?? [] });

	} catch (e) {
		console.log('fetchFundsReserveConfigList error', e);
		dispatch({ type: merchantActionTypes.SET_FUNDS_RESERVE_CONFIG_INACTIVE_LIST_DATA_LOADING, payload: false });
	}
};

export const setFundsReserveConfig = async (formik: any, onSuccess, onError, id): Promise<void> => {
	try {
		if (!formik.isValid) return;
		const body: FundsReserveConfigFieldsReturnTypes = getFormattedFundsReserveConfigFields(formik.values);
		if (body?.disputeRateMin > body?.disputeRateMax) {
			formik.setErrors({ [FUNDS_RESERVE_CONFIG_FORM_FIELDS.DISPUTE_RATE_START]: 'Dispute rate from must not be bigger than Dispute rate to' });
			return;
		}
		if (id) {
			body.id = id;
			await PUT({
				pathname: `${BASE_URL.MERCHANTS}/fundsReserve`,
				body
			});
		}
		onSuccess();
	} catch (e) {
		console.log('setFundsReserveConfig error', e);
		onError();
	}
};

export const setMerchantFundReserveConfig = async (dispatch: Dispatch<IAction>, mid: string, id: string): Promise<void> => {
	try {
		dispatch({ type: merchantActionTypes.SET_MERCHANT_FUNDS_RESERVE_CONFIG_LOADING, payload: true });

		await PUT({
			pathname: `${BASE_URL.MERCHANTS}/merchant/${mid}/funds-reserve-config`,
			body: {
				fundsReserveConfigurationId: id
			}
		});

		dispatch({ type: merchantActionTypes.SET_MERCHANT_FUNDS_RESERVE_CONFIG_LOADING, payload: false });
	} catch (e) {
		console.log('fetchMerchantFundsReserveConfigList error', e);
		dispatch({ type: merchantActionTypes.SET_MERCHANT_FUNDS_RESERVE_CONFIG_LOADING, payload: false });
	}
};

export const removeMerchantFundReserveConfig = async (mid: string, id: string, onSuccess: () => void, onError: () => void): Promise<void> => {
	try {

		await DELETE({
			pathname: `${BASE_URL.MERCHANTS}/merchant/${mid}/funds-reserve-config`,
			body: {
				id: id,
			},
		});

		onSuccess();
	} catch (e) {
		console.log('removeMerchantFundReserveConfig error', e);
		onError();
	}
};
